import React, { useContext, useEffect, useState } from "react";
import { Transition, Dialog } from "@headlessui/react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { API_URL_agentEmail, API_URL_ticketCollaborator } from "constants/api";
import { toast } from "react-toastify";
import axios from "axios";
import { AuthContext } from "context/AuthContext";
import { FaUserFriends, FaUserPlus } from "react-icons/fa";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const ModalAddCC = ({ isOpen, onClose, item, callback }) => {
  const cancelButtonRef = React.useRef(null);

  const [email, setEmail] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const handleEmailChange = async (value) => {
    const inputValue = value;

    try {
      const response = await axios.get(
        `${API_URL_agentEmail}?query=${inputValue}`
      );
      setSuggestions(response.data.suggestions);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const handleclose = () => {
    setSuggestions([]);
    setEmail("");
    onClose();
  };

  const search = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("User Email must be a valie email")
        .required("User Email is required"),
    }),
    onSubmit: (values) => {
      axios({
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        method: "POST",
        data: { email: values.email, type: "search", ticket: item },
        url: API_URL_ticketCollaborator,
      })
        .then((response) => {
          toast.success("Add Recipient Successfully", {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          callback();
          handleclose();
        })
        .catch((error) => {
          console.log(error);
          toast.warning(error.response?.data.message, {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        });
    },
  });

  const add = useFormik({
    initialValues: {
      username: "",
      email: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Username is required"),
      email: Yup.string()
        .email("User Email must be a valid email")
        .required("Email is required"),
    }),
    onSubmit: (values) => {
      axios({
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        method: "POST",
        data: {
          email: values.email,
          type: "add",
          username: values.username,
          ticket: item,
        },
        url: API_URL_ticketCollaborator,
      })
        .then((response) => {
          toast.success("Add User & Add Collaborator Successfully", {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          callback();
          handleclose();
        })
        .catch((error) => {
          console.log(error);
          toast.warning(error.response?.data.message, {
            position: "top-center",
            autoClose: true,
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        });
    },
  });

  useEffect(() => {
    handleEmailChange(search.values.email);
  }, [search.values.email]);

  return (
    <Transition.Root show={isOpen} as={React.Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={() => handleclose()}
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-start justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-al w-full lg:w-1/2">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="mt-3 sm:ml-4 sm:mt-0">
                    <div className="flex justify-between">
                      <Dialog.Title
                        as="h3"
                        className="text-2xl font-semibold leading-6 text-gray-900"
                      >
                        Add collaborator
                      </Dialog.Title>
                      <button
                        type="button"
                        className=" bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                        onClick={() => handleclose()}
                      >
                        X
                      </button>
                    </div>
                    <Tabs className="py-4 px-2">
                      <TabList>
                        <Tab>
                          <div className="text-green-600 flex items-center gap-2">
                            <span>
                              <FaUserFriends />
                            </span>
                            <span>Search Existing Users</span>
                          </div>
                        </Tab>
                        <Tab>
                          <div className="text-yellow-600 flex items-center gap-2">
                            <span>
                              <FaUserPlus />
                            </span>
                            <span>Add New User</span>
                          </div>
                        </Tab>
                      </TabList>

                      <TabPanel>
                        <form onSubmit={search.handleSubmit}>
                          <div className="mt-3 sm:ml-4 sm:mt-0">
                            <div className="px-6 py-1">
                              <label htmlFor="link" className="block mb-1">
                                Select User Email
                                <span className="text-red-500">*</span>
                              </label>

                              <input
                                type="text"
                                className="w-full p-2 border border-gray-300 rounded-md mb-2"
                                placeholder="Enter & search email User"
                                id="custom-email-field"
                                name="email"
                                autoComplete="off"
                                aria-autocomplete="off"
                                value={search.values.email}
                                onChange={search.handleChange}
                              />
                              <ul className="list-none max-h-60 overflow-y-auto">
                                {suggestions.map((suggest, index) => (
                                  <li
                                    className={`hover:bg-gray-300 bg-gray-100 py-0.5 my-1 cursor-pointer `}
                                    key={index}
                                    onClick={() =>
                                      search.setFieldValue("email", suggest)
                                    }
                                  >
                                    {suggest}
                                  </li>
                                ))}
                              </ul>

                              {search.touched.email && search.errors.email && (
                                <div className="text-red-500 dark:text-red-300 text-xs">
                                  {search.errors.email}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="bg-gray-50 flex justify-between px-4 py-3 sm:px-6">
                            <button
                              type="button"
                              className="inline-flex justify-center rounded-md bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                              onClick={() => handleclose()}
                            >
                              Close
                            </button>
                            <button
                              type="submit"
                              className="inline-flex justify-center rounded-md bg-sky-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-600"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      </TabPanel>
                      <TabPanel>
                        <form onSubmit={add.handleSubmit}>
                          <div className="mt-3 sm:ml-4 sm:mt-0">
                            <div className="px-6 py-1">
                              <label htmlFor="link" className="block mb-1">
                                Username
                                <span className="text-red-500">*</span>
                              </label>

                              <input
                                type="text"
                                className="w-full p-2 border border-gray-300 rounded-md mb-2"
                                placeholder="Enter Username"
                                name="username"
                                autoComplete="off"
                                aria-autocomplete="off"
                                value={add.values.username}
                                onChange={add.handleChange}
                              />

                              {add.touched.username && add.errors.username && (
                                <div className="text-red-500 dark:text-red-300 text-xs">
                                  {add.errors.username}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="mt-3 sm:ml-4 sm:mt-0">
                            <div className="px-6 py-1">
                              <label htmlFor="link" className="block mb-1">
                                Email
                                <span className="text-red-500">*</span>
                              </label>

                              <input
                                type="text"
                                className="w-full p-2 border border-gray-300 rounded-md mb-2"
                                placeholder="Enter Email"
                                name="email"
                                autoComplete="off"
                                aria-autocomplete="off"
                                value={add.values.email}
                                onChange={add.handleChange}
                              />

                              {add.touched.email && add.errors.email && (
                                <div className="text-red-500 dark:text-red-300 text-xs">
                                  {add.errors.email}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="bg-gray-50 flex justify-between px-4 py-3 sm:px-6">
                            <button
                              type="button"
                              className="inline-flex justify-center rounded-md bg-gray-300 px-3 py-2 text-sm font-semibold text-black shadow-sm hover:bg-gray-400"
                              onClick={() => handleclose()}
                            >
                              Close
                            </button>
                            <button
                              type="submit"
                              className="inline-flex justify-center rounded-md bg-sky-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-600"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      </TabPanel>
                    </Tabs>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ModalAddCC;
